import { Center, Loader, Stack, Text } from '@mantine/core'
import { showNotification } from '@mantine/notifications'
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { trpc } from '../lib/trpc'
import { useAuthStore } from '../store/useAuthStore'

function ImpersonatePage() {
  const navigate = useNavigate()
  const { setUser } = useAuthStore()
  const { token } = Route.useSearch()
  const hasInitiated = useRef(false)

  const utils = trpc.useUtils()

  const validateMutation = trpc.auth.validateImpersonation.useMutation({
    onSuccess: async () => {
      // Fetch current user data after token is set
      const userData = await utils.user.me.fetch()

      setUser({
        id: userData.id,
        email: userData.email,
        firstName: userData.firstName,
        lastName: userData.lastName,
        roles: userData.roles,
        isImpersonating: true,
      })

      showNotification({
        title: 'Impersonointi onnistui',
        message: `Kirjauduttu käyttäjänä ${userData.firstName} ${userData.lastName}`,
        color: 'green',
      })

      navigate({ to: '/home' })
    },
    onError: (error) => {
      showNotification({
        title: 'Virhe',
        message: error.message || 'Impersonointi epäonnistui',
        color: 'red',
      })
      navigate({ to: '/' })
    },
  })

  useEffect(() => {
    if (!hasInitiated.current) {
      hasInitiated.current = true
      validateMutation.mutate({ token })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Center h="100vh">
      <Stack align="center">
        <Loader size="lg" />
        <Text>Kirjaudutaan sisään...</Text>
      </Stack>
    </Center>
  )
}

export const Route = createFileRoute('/impersonate')({
  component: ImpersonatePage,
  validateSearch: (search: Record<string, unknown>) => ({
    token: (search.token as string) || '',
  }),
  beforeLoad: ({ search }) => {
    if (!search.token) {
      throw redirect({ to: '/' })
    }
  },
})
